declare namespace $ {

	type $shm_textarea_code__value_shm_hitalama_map_widget_float_text_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['text'] >
		,
		ReturnType< $shm_textarea_code['value'] >
	>
	type $shm_textarea_code__selection_shm_hitalama_map_widget_float_text_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['selection'] >
		,
		ReturnType< $shm_textarea_code['selection'] >
	>
	type $shm_textarea_code__spellcheck_shm_hitalama_map_widget_float_text_3 = $mol_type_enforce<
		boolean
		,
		ReturnType< $shm_textarea_code['spellcheck'] >
	>
	type $shm_textarea_code__style_shm_hitalama_map_widget_float_text_4 = $mol_type_enforce<
		({ 
			'color': ReturnType< $shm_hitalama_map_widget_float_text['color'] >,
			'fontSize': ReturnType< $shm_hitalama_map_widget_float_text['font_size_px'] >,
			'height': ReturnType< $shm_hitalama_map_widget_float_text['textarea_height'] >,
			'position': ReturnType< $shm_hitalama_map_widget_float_text['textarea_position'] >,
		})  & ReturnType< $shm_textarea_code['style'] >
		,
		ReturnType< $shm_textarea_code['style'] >
	>
	type $mol_view__style_shm_hitalama_map_widget_float_text_5 = $mol_type_enforce<
		({ 
			'transform': ReturnType< $shm_hitalama_map_widget_float_text['blocker_transform'] >,
		}) 
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__event_shm_hitalama_map_widget_float_text_6 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $shm_hitalama_map_widget_float_text['blocker_pointerdown'] > ): ReturnType< $shm_hitalama_map_widget_float_text['blocker_pointerdown'] >,
			pointerup( next?: ReturnType< $shm_hitalama_map_widget_float_text['blocker_pointerup'] > ): ReturnType< $shm_hitalama_map_widget_float_text['blocker_pointerup'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__attr_shm_hitalama_map_widget_float_text_7 = $mol_type_enforce<
		({ 
			'is_button': ReturnType< $shm_hitalama_map_widget_float_text['is_button'] >,
		}) 
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_image__uri_shm_hitalama_map_widget_float_text_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['image_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_paragraph__title_shm_hitalama_map_widget_float_text_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_string__value_shm_hitalama_map_widget_float_text_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['viewport_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__hint_shm_hitalama_map_widget_float_text_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['link_to_viewport_hint'] >
		,
		ReturnType< $mol_string['hint'] >
	>
	type $shm_hitalama_color_pick__color_shm_hitalama_map_widget_float_text_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['color'] >
		,
		ReturnType< $shm_hitalama_color_pick['color'] >
	>
	type $shm_hitalama_color_pick__color_default_shm_hitalama_map_widget_float_text_13 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_color_pick['color_default'] >
	>
	type $shm_hitalama_color_pick__hint_shm_hitalama_map_widget_float_text_14 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_color_pick['hint'] >
	>
	type $shm_hitalama_map_fontsize__font_size_shm_hitalama_map_widget_float_text_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['font_size'] >
		,
		ReturnType< $shm_hitalama_map_fontsize['font_size'] >
	>
	type $shm_hitalama_map_widget_tools__widget_shm_hitalama_map_widget_float_text_16 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['widget'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['widget'] >
	>
	type $shm_hitalama_map_widget_tools__Map_page_shm_hitalama_map_widget_float_text_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['Map_page'] >
	>
	type $shm_hitalama_map_widget_tools__settings_content_shm_hitalama_map_widget_float_text_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_text['settings_content'] >
		,
		ReturnType< $shm_hitalama_map_widget_tools['settings_content'] >
	>
	type $shm_hitalama_map_widget_tools__sub_shm_hitalama_map_widget_float_text_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_map_widget_tools['sub'] >
	>
	export class $shm_hitalama_map_widget_float_text extends $shm_hitalama_map_widget_float {
		text( next?: string ): string
		selection( next?: readonly(number)[] ): readonly(number)[]
		text_focused( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Text'] >['focused'] >
		textarea_height( ): string
		textarea_position( ): string
		Text( ): $shm_textarea_code
		blocker_transform( ): string
		blocker_pointerdown( next?: any ): any
		blocker_pointerup( next?: any ): any
		is_button( ): boolean
		Blocker( ): $mol_view
		blocker( ): readonly(any)[]
		image_uri( ): string
		Image( ): $mol_image
		image( ): readonly(any)[]
		Link_to_viewport_label( ): $mol_paragraph
		viewport_id( next?: string ): string
		link_to_viewport_hint( ): string
		Link_to_viewport( ): $mol_string
		settings_tool_visible( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['settings_tool_visible'] >
		settings_bubble_content( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['settings_bubble_content'] >
		Up( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Up'] >
		Down( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Down'] >
		Copy_code( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Copy_code'] >
		Auto_height( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Auto_height'] >
		Lock( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Lock'] >
		Fullscreen( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Fullscreen'] >
		Link_pick( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Link_pick'] >
		Delete( ): ReturnType< ReturnType< $shm_hitalama_map_widget_float_text['Tools'] >['Delete'] >
		color( next?: string ): string
		Color( ): $shm_hitalama_color_pick
		font_size( next?: number ): number
		Font_size_tool( ): $shm_hitalama_map_fontsize
		font_tools( ): readonly(any)[]
		controls( ): readonly(any)[]
		settings_content( ): readonly(any)[]
		Tools( ): $shm_hitalama_map_widget_tools
		tools_custom( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=text.view.tree.d.ts.map